import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const LayoutContent = ({ data, props }) => {
  const { title, children } = props;
  const [toggleNav, setToggleNav] = React.useState(false);
  // console.log(data);
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div id="menu" className="site-head-container">
          <a className="nav-burger" href={`#menu`} onClick={() => setToggleNav(!toggleNav)}>
            <div
              className="hamburger hamburger--collapse"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>{" "}
              <div className="hamburger-text-menu-text hidden">Menu</div>
            </div>
          </a>
          <nav id="swup" className="site-head-left">
            <ul className="nav" role="menu">
              {/* <li className="nav-home nav-current" role="menuitem">
                <Link to={`/`}>Home</Link>
              </li> */}
              <li className="nav-tags" role="menuitem">
                <Link to={`/tags`}>Proyectos</Link>
              </li>
              <li className="nav-services" role="menuitem">
                <Link to={`/services`}>Servicios</Link>
              </li>
              <li className="nav-about" role="menuitem">
                <Link to={`/about`}>Nosotros</Link>
              </li>
              <li className="nav-contact" role="menuitem">
                <Link to={`/contact`}>Contacto</Link>
              </li>
            </ul>
          </nav>
          <div className="site-head-right">
            <Link className="site-head-logo" to={`/`}>
              {/* <Img fluid={data.logoLight.childImageSharp.fluid} className="site-head-logo-light" /> */}
              <GatsbyImage
                image={data.logoDark.childImageSharp.gatsbyImageData}
                alt="logotipo DACS con la C sobresaliendo"
                className="site-head-logo-dark" />

              {/* {title}DA
              <mark className="green">C</mark>S */}
            </Link>
          </div>
          {/* <div className="site-head-right">
            <div className="social-links">
              <a
                href="https://www.facebook.com"
                title="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://instagram.com"
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
              {/* <Link to={`/rss.xml`} title="RSS" target="_blank" rel="noopener noreferrer">
                RSS
              </Link> */}
          {/* </div> */}
          {/* </div> */}
        </div>
      </header>
      <main id="site-main" className="site-main">
        <div id="swup" className="transition-fade">
          {children}
        </div>
      </main>
      <footer className="site-foot">
        &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link> &mdash; Powered by{" "}
        <a href="https://foodstamp.tech" target="_blank" rel="noopener noreferrer">
          Not Seen Tech
        </a>
      </footer>
    </div>
  );
};

const Layout = props => {
  return (
    <StaticQuery query={indexQuery} render={data => <LayoutContent data={data} props={props} />} />
  );
};

const indexQuery = graphql`{
  logoDark: file(relativePath: {eq: "logo_DACSwhite.png"}) {
    childImageSharp {
      gatsbyImageData(width: 142, layout: CONSTRAINED)
    }
  }
  logoLight: file(relativePath: {eq: "logo_DACSblack.png"}) {
    childImageSharp {
      gatsbyImageData(width: 142, layout: CONSTRAINED)
    }
  }
}
`;

export default Layout;
